import { Checkbox } from "../ui/checkbox";

export const emptyAccess = (role = "agent") => ({ role, agency_ids: [], service_ids: [], granted_permissions: [], revoked_permissions: [] });

const toggleIn = (list, id) => (list.includes(id) ? list.filter((x) => x !== id) : [...list, id]);

const ScopePicker = ({ value, onChange, agencies, services }) => (
  <div className="grid gap-3 sm:grid-cols-2" data-testid="access-scope">
    {[["agency_ids", "Agences autorisées", agencies], ["service_ids", "Services autorisés", services]].map(([k, label, items]) => (
      <div key={k}>
        <p className="eyebrow mb-1.5">{label}</p>
        <div className="max-h-36 space-y-1 overflow-y-auto rounded-md border p-2">
          {!(items || []).length && <p className="text-xs text-slate-400">Aucun élément</p>}
          {(items || []).map((it) => (
            <label key={it.id} className="flex items-center gap-2 text-sm">
              <Checkbox checked={value[k].includes(it.id)} onCheckedChange={() => onChange({ ...value, [k]: toggleIn(value[k], it.id) })} data-testid={`scope-${k}-${it.id}`} />{it.name}
            </label>
          ))}
        </div>
      </div>
    ))}
  </div>
);

const Matrix = ({ value, onChange, catalog, rolePerms, mine }) => {
  const has = (k) => (rolePerms.includes(k) && !value.revoked_permissions.includes(k)) || value.granted_permissions.includes(k);
  const toggle = (k) => {
    if (rolePerms.includes(k)) onChange({ ...value, revoked_permissions: toggleIn(value.revoked_permissions, k) });
    else onChange({ ...value, granted_permissions: toggleIn(value.granted_permissions, k) });
  };
  return (
    <div className="space-y-3" data-testid="access-matrix">
      {catalog.map((m) => (
        <div key={m.module}>
          <p className="text-sm font-medium">{m.label}</p>
          <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
            {m.actions.map((a) => {
              const locked = value.role === "owner" || (!rolePerms.includes(a.key) && (!mine.includes(a.key) || a.key === "company:manage"));
              return (
                <label key={a.key} className={`flex items-center gap-1.5 text-xs ${locked ? "text-slate-400" : "text-slate-700"}`}>
                  <Checkbox checked={has(a.key)} disabled={locked} onCheckedChange={() => toggle(a.key)} data-testid={`perm-${a.key}`} />{a.label}
                </label>
              );
            })}
          </div>
        </div>
      ))}
      <p className="text-xs text-slate-400">Cases grisées : droit que vous ne détenez pas vous-même ou réservé à l'administrateur.</p>
    </div>
  );
};

export default function AccessFields({ value, onChange, meta, agencies, services }) {
  const role = meta.roles.find((r) => r.key === value.role);
  const unscoped = ["owner", "manager"].includes(value.role);
  return (
    <div className="space-y-4">
      <label className="block text-sm"><span className="eyebrow">Rôle</span>
        <select className="field-select mt-1.5" value={value.role} onChange={(e) => onChange({ ...emptyAccess(e.target.value), agency_ids: value.agency_ids, service_ids: value.service_ids })} data-testid="access-role-select">
          {meta.roles.filter((r) => r.assignable || r.key === value.role).map((r) => <option key={r.key} value={r.key} disabled={!r.assignable}>{r.label}</option>)}
        </select>
      </label>
      {!unscoped && <><p className="text-xs text-slate-500">{role?.scoped ? "Ce rôle ne voit que les feedbacks des agences/services cochés (et ceux qui lui sont affectés)." : "Facultatif : cochez des agences ou services pour restreindre l'accès."}</p>
        <ScopePicker value={value} onChange={onChange} agencies={agencies} services={services} /></>}
      <Matrix value={value} onChange={onChange} catalog={meta.catalog} rolePerms={role?.permissions || []} mine={meta.mine} />
    </div>
  );
}
